import styled from "styled-components";

export const BreadcrumbContainer = styled.div`
  margin-top: 24px;
`;

export const BadgeWrap = styled.div`
  position: absolute;
  width: 568px;
  background: #fff;
  z-index: 100;
  max-height: 210px;
  overflow-y: scroll;
  padding: 16px;
  margin-top: 4px;
  border-radius: 12px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 52px;
  width: 100%;
`;
